import { Dispatch } from 'redux';

export const resetApp = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: 'RESET_APPLICATION_STATE' });
  };
};
